module.exports = __webpack_public_path__ + "img/investpr.e58f9c19.svg";